export function shouldEnableCloudSync(input: {
  development: boolean;
  origin: string;
  allowedOrigins: string | undefined;
}): boolean {
  if (!input.development) return true;
  const allowed = new Set((input.allowedOrigins ?? "")
    .split(",")
    .map((origin) => origin.trim())
    .filter(Boolean));
  return allowed.has(input.origin);
}
